import Blockchain_nft_data_source_class from '../datasource/nft_data_source.js'
import Marketplace_data_source_class from '../datasource/marketplace_data_source.js'
import _ from 'underscore'
const async = require('async')

class Get_nfts_on_sale_for_user_account_usecase {
  constructor () {
    this.NftDataSource = new Blockchain_nft_data_source_class()
    this.MarketplaceDataSource = new Marketplace_data_source_class()

    this.NftInformation = class {
      constructor (
        tokenId,
        croppedBase64PngString,
        fullBase64PngString,
        complete,
        saleInformation
      ) {
        this.tokenId = tokenId
        this.croppedBase64PngString = croppedBase64PngString
        this.fullBase64PngString = fullBase64PngString
        this.complete = complete
        this.saleInformation = saleInformation
      }
    }
  }

  async execute () {
    var _this = this

    const mySalesItems = await this.MarketplaceDataSource.fetchAllSalesItemsForAccount()
    const myNftsOnSale = await async.map(mySalesItems, async function (
      saleItem,
      callback
    ) {
      const nftInfo = await _this.NftDataSource.fetchTokenInfoForTokenId(
        saleItem.tokenId
      )

      callback(
        null,
        new _this.NftInformation(
          saleItem.tokenId,
          nftInfo.croppedBase64PngString,
          nftInfo.fullBase64PngString,
          nftInfo.complete,
          saleItem
        )
      )
    })

    return myNftsOnSale
  }
}

export default Get_nfts_on_sale_for_user_account_usecase
